import { render, staticRenderFns } from "./ReportText.vue?vue&type=template&id=9cbb9368&scoped=true&"
import script from "./ReportText.vue?vue&type=script&lang=js&"
export * from "./ReportText.vue?vue&type=script&lang=js&"
import style0 from "./ReportText.vue?vue&type=style&index=0&id=9cbb9368&scoped=true&lang=css&"
import style1 from "./ReportText.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cbb9368",
  null
  
)

export default component.exports